import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { Box, DialogContent, DialogTitle, Divider, Grid, IconButton, Typography } from '@mui/material';
import ResponsiveDialog from 'components/Common/ResponsiveDialog';
import { closeAllModals } from 'reducers/modalReducer';
import { JBAlert, JBColors, JBIcon } from '@bjb-gcrm/gcrm-frontend-components';

const DisableBrOpenTasksModal = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  return (
    <ResponsiveDialog id="open-tasks-modal">
      <DialogContent>
        <DialogTitle id="open-tasks-modal-title" sx={{ padding: 0 }}>
          <Grid container justifyContent="space-between">
            <Grid item container xs={11} alignItems="center">
              <JBIcon iconName="dangerOutline" size="xl" fill={JBColors.support.orange[120]} />
              <Typography variant="h5" display="inline" ml="16px" color={JBColors.support.orange[120]}>
                {t(
                  'accounts.tabs.more.deactivate.openTasks.modal.title',
                  'BR deactivation - additional action required',
                )}
              </Typography>
            </Grid>

            <Grid item xs={1}>
              <IconButton onClick={() => dispatch(closeAllModals())}>
                <JBIcon iconName="close" fill={JBColors.support.orange[120]} size="xl" />
              </IconButton>
            </Grid>
          </Grid>
          <Divider sx={{ borderColor: JBColors.support.orange[120] }} />
        </DialogTitle>

        <Box sx={{ marginTop: '8px' }}>
          <JBAlert color="warning">
            {t(
              'accounts.tabs.more.deactivate.modal.tasksOpenError',
              'In order to deactivate the BR, kindly close all open tasks related to this BR or its related partner.',
            )}
          </JBAlert>
        </Box>
      </DialogContent>
    </ResponsiveDialog>
  );
};

export default DisableBrOpenTasksModal;
